import { appsSearchQueryKeys } from "app/pages/sales-intelligence/modules/apps-search/query/key-factory/factory";
import type { AppsSearchRequestDto } from "app/pages/sales-intelligence/modules/apps-search/types/dto";
import {
    type LeadsSearchRequestDto,
    type LeadsType,
    leadsSearchQueryKeys,
} from "app/pages/sales-intelligence/modules/leads-search";

const BASE_QUERY_KEY = "advanced-search";

/**
 * @description
 * Creates React Query keys for advanced search operations
 *
 * @dependency `leadsSearchQueryKeys`
 * This dependency serves two purposes:
 * 1. **Query Key Hierarchy**: Establishes a parent-child relationship where advanced search
 *    is a specialization of leads search
 * 2. **Cache Invalidation**: When `leadsSearchQueryKeys.tableData()` is invalidated, all
 *    dependent queries (including advanced search) are automatically invalidated
 */
export const advancedSearchQueryKeyFactory = {
    tableData(sourceType?: LeadsType, dto?: LeadsSearchRequestDto) {
        const base = [...leadsSearchQueryKeys.tableData(), BASE_QUERY_KEY] as const;

        if (sourceType && dto) {
            return [...base, sourceType, dto];
        }

        if (sourceType) {
            return [...base, sourceType];
        }

        if (dto) {
            return [...base, dto];
        }

        return base;
    },

    appsTableData(dto?: AppsSearchRequestDto) {
        const base = [...appsSearchQueryKeys.tableData(), BASE_QUERY_KEY] as const;

        if (dto) {
            return [...base, dto];
        }

        return base;
    },
} as const;
